import { render, staticRenderFns } from "./RedirectToPost.vue?vue&type=template&id=cf06e032&"
import script from "./RedirectToPost.vue?vue&type=script&lang=js&"
export * from "./RedirectToPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports